var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSilverfortApi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 33,
    viewBox: "0 0 27 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#6B696A",
    d: "M23.161.978c-.013 3.253-.002 6.506-.02 9.759-.002.202-.147.463-.308.596-4.05 3.352-8.11 6.691-12.17 10.03-.035.029-.086.039-.19.084-.307-.372-.625-.758-.99-1.198.214-.19.401-.368.6-.532 3.63-2.99 7.255-5.984 10.895-8.961.37-.301.533-.604.528-1.09-.025-2.477-.012-4.955-.012-7.507h-2.492v1.84h-1.629V.543c.153-.025.291-.066.43-.067 1.591-.005 3.184.003 4.777-.009.372-.002.582.069.581.511zM7.511.517v3.482H5.938v-1.83h-2.49c-.022.206-.058.391-.058.576-.003 2.336-.01 4.671.007 7.007.002.268.073.593.234.793 1.633 2.027 3.29 4.032 4.943 6.041.043.053.11.086.22.167l7.424-6.134 1.057 1.255-8.759 7.247c-1.907-2.325-3.705-4.62-5.623-6.811-.852-.974-1.197-1.953-1.15-3.24.094-2.573.028-5.153.028-7.729V.517h5.74zm6.658 7.595l1.057 1.253-.639.541-1.277 1.079-4.527 3.828V9.291h1.536v1.83l.188.077 3.662-3.086zM16.15 0v4.853h-1.606v-3.23h-4.179v6.121H8.773V0h7.377z",
    transform: "translate(-926 -415) translate(927.166 415.596)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M23.471 30.973H1.189C.533 30.973 0 30.441 0 29.785V19.186c0-.656.533-1.19 1.189-1.19h22.282c.657 0 1.189.534 1.189 1.19v10.6c0 .655-.532 1.187-1.189 1.187",
    transform: "translate(-926 -415) translate(927.166 415.596)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#368FEF",
    strokeLinecap: "square",
    strokeWidth: 1.5,
    d: "M23.471 30.973H1.189C.533 30.973 0 30.441 0 29.785V19.186c0-.656.533-1.19 1.189-1.19h22.282c.657 0 1.189.534 1.189 1.19v10.6c0 .655-.532 1.187-1.189 1.187z",
    transform: "translate(-926 -415) translate(927.166 415.596)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#368FEF",
    fontFamily: "Roboto-Bold, Roboto",
    fontSize: 9.72,
    fontWeight: "bold",
    transform: "translate(-926 -415) translate(927.166 415.596)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 4.62,
    y: 28.238
  }, "API")))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilverfortApi);
export default __webpack_public_path__ + "static/media/silverfort_api.10a0db17e982f10a204356bf9d2c7c95.svg";
export { ForwardRef as ReactComponent };